import * as z from "zod";

export const enrollImsBilling = {
  name: "enrollImsBilling" as const,
  input: z.object({
    /** Whether to enable IMS subscription billing */
    enableSubscription: z.boolean(),
    /** Whether to enable forecasting billing */
    enableForecasting: z.boolean(),
    /** Whether to bill annually (true) or monthly (false) */
    annualBilling: z.boolean(),
  }),
  output: z.object({ success: z.boolean() }),
};
